import React from 'react'

function Limpieza({...r}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" {...r}>
      <path
        fill="#00033A"
        d="M42.68 58.66c-.55 0-1-.45-1-1 0-8.55-6.96-15.5-15.5-15.5-.55 0-1-.45-1-1s.45-1 1-1c8.55 0 15.5-6.96 15.5-15.5 0-.55.45-1 1-1s1 .45 1 1c0 8.55 6.96 15.5 15.5 15.5.55 0 1 .45 1 1s-.45 1-1 1c-8.55 0-15.5 6.96-15.5 15.5 0 .55-.45 1-1 1zm-10.67-17.5c4.96 1.76 8.91 5.7 10.67 10.67 1.76-4.96 5.7-8.91 10.67-10.67-4.96-1.76-8.91-5.7-10.67-10.67a17.62 17.62 0 01-10.67 10.67z"
      ></path>
      <path
        fill="#126FFF"
        d="M17.38 37.99c-.55 0-1-.45-1-1 0-6.07-4.94-11-11-11-.55 0-1-.45-1-1s.45-1 1-1c6.07 0 11-4.94 11-11 0-.55.45-1 1-1s1 .45 1 1c0 6.07 4.94 11 11 11 .55 0 1 .45 1 1s-.45 1-1 1c-6.07 0-11 4.94-11 11 0 .55-.45 1-1 1zm-7.01-13.01c3.15 1.32 5.68 3.85 7 7 1.32-3.15 3.85-5.68 7-7a13.108 13.108 0 01-7-7 13.009 13.009 0 01-7 7z"
      ></path>
      <path
        fill="#00033A"
        d="M35.32 17.87c-.55 0-1-.45-1-1V6.52c0-.55.45-1 1-1s1 .45 1 1v10.35c0 .55-.45 1-1 1z"
      ></path>
      <path
        fill="#00033A"
        d="M40.49 12.69H30.15c-.55 0-1-.45-1-1s.45-1 1-1H40.5c.55 0 1 .45 1 1s-.45 1-1.01 1z"
      ></path>
      <path
        fill="#126FFF"
        d="M22.75 56.15c-.55 0-1-.45-1-1v-6.82c0-.55.45-1 1-1s1 .45 1 1v6.82c0 .56-.44 1-1 1z"
      ></path>
      <path
        fill="#126FFF"
        d="M26.16 52.74h-6.82c-.55 0-1-.45-1-1s.45-1 1-1h6.82c.55 0 1 .45 1 1s-.44 1-1 1z"
      ></path>
    </svg>
  )
}

export default Limpieza